import { useEffect } from 'react';
import { toast } from 'sonner';
import { useOtaUpdate } from '@/hooks/useOtaUpdate';

/**
 * Single instance component that shows OTA update toasts.
 * Rendered once in App.tsx to avoid duplicate toasts from multiple Header instances.
 */
export function OtaUpdateNotifier() {
  const { isDownloading, isReadyToInstall } = useOtaUpdate();

  useEffect(() => {
    if (!isDownloading) return;
    toast('Downloading update...', { id: 'ota-update', duration: Infinity });
  }, [isDownloading]);

  useEffect(() => {
    if (!isReadyToInstall) return;
    toast('Update ready', {
      id: 'ota-update',
      description: 'A new version will be applied next time you open the app.',
      duration: 5000,
    });
  }, [isReadyToInstall]);

  return null;
}
